<div class="Modal">
  <div class="HeaderModal">
    <div class="IconModal float-start">
      <p>contrato de assistência financeira</p>
    </div>
    <span class="material-icons float-end CloseModal" [mat-dialog-close]="true"> close </span>
  </div>
  <div class="ModalContent">
      <p>
        aqui carrega o pdf do contrato
      </p>
      <a href="#" class="BaixarContrato">
        <mat-icon>download</mat-icon>
        Baixar o contrato
      </a>
  </div>
</div>
